import { Translation } from '@shared/types/translation';

export const CONTACT_REQUEST_LABELS = {
  UPDATE_STATUS_MODAL_TITLE: {
    english: 'Update Contact Request Status',
    polish: 'Zaktualizuj status zgłoszenia kontaktowego',
  },
  CREATE_CR_SECTION_DETAILS: {
    english: 'Contact Request Details:',
    polish: 'Szczegóły zgłoszenia kontaktowego:',
  },
  UPDATE_STATUS_BUTTON_CONTINUE: {
    english: 'Continue',
    polish: 'Kontynuuj',
  },
  CANCEL_CR_BUTTON_SUBMITTING: {
    english: 'Cancelling Request...',
    polish: 'Anulowanie zgłoszenia…',
  },
  CANCEL_CR_REASON_LABEL: {
    english: 'Enter a Reason for Cancellation',
    polish: 'Podaj powód anulowania',
  },
  // Shared by ASSIGN_CR_FIELD_ADMIN_ID and VIEW_CR_FIELD_ASSIGNEE_ID in the
  // legacy pl.ts — both are the identical "Admin ID" field label.
  ADMIN_ID_LABEL: {
    english: 'Admin ID',
    polish: 'Identyfikator administratora',
  },
  VIEW_CR_BUTTON_ASSIGN: {
    english: 'Assign',
    polish: 'Przydziel',
  },
  // Shared by VIEW_CR_NAV_ASSIGNEE_DETAILS and VIEW_CR_SECTION_ASSIGNEE_DATA
  // in the legacy pl.ts — both are the identical "Assignee Details" text
  // (one is the tab nav label, the other the section heading inside it).
  ASSIGNEE_DETAILS_LABEL: {
    english: 'Assignee Details',
    polish: 'Dane osoby przydzielonej',
  },
  VIEW_CR_ASSIGNEE_EMPTY: {
    english: 'This request has not been assigned to any user yet.',
    polish:
      'To zgłoszenie nie zostało jeszcze przydzielone żadnemu użytkownikowi.',
  },
  // Shared field labels across the "Assignee Details" and "Assigned By" cards.
  ASSIGNEE_FIELD_NAME: {
    english: 'Name',
    polish: 'Nazwa',
  },
  ASSIGNEE_FIELD_ROLE: {
    english: 'Role',
    polish: 'Rola',
  },
  ASSIGNEE_FIELD_EMAIL: {
    english: 'Email Address',
    polish: 'Adres e-mail',
  },
  ASSIGNEE_FIELD_PHONE: {
    english: 'Phone Number',
    polish: 'Numer telefonu',
  },
  ASSIGNED_BY_LABEL: {
    english: 'Assigned By',
    polish: 'Przydzielono przez',
  },
  // Display labels for the raw `ADMIN` / `SUPER_ADMIN` role codes.
  ROLE_ADMIN_VALUE: {
    english: 'Administrator',
    polish: 'Administrator',
  },
  ROLE_SUPER_ADMIN_VALUE: {
    english: 'Super Admin',
    polish: 'Super administrator',
  },
} as const satisfies Record<string, Translation>;
